import { Button, ComboBox, LoadingIndicator } from '@components';
import { months } from '@utils';
import { getYear } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import api from '../../../../../common/services/api';
import './styles.css';

export const AnoMesContraCheque = ({
  urlGetPDF,
  relatorio = 'extrato contracheque',
}) => {
  const dataAtual = new Date();
  const user = useSelector((state) => state.user);
  const custom = useSelector((state) => state.customizaSistema);
  const anoLimite = user.corteContracheque[1];
  const mesLimite = user.corteContracheque[0];
  const [isLoading, setIsLoading] = useState(false);
  const [anoSelecionado, setAnoSelecionado] = useState(anoLimite);
  const [mesSelecionado, setMesSelecionado] = useState(mesLimite);
  const [habilitarPDF, setHabilitarPDF] = useState(false);
  const [habilitarSelecaoMeses, setHabilitarSelecaoMeses] = useState(false);
  const [opcoesMeses, setOpcoesMeses] = useState(
    months.sort((a, b) => {
      return b.numero.localeCompare(a.numero);
    })
  );

  const dataInicialSplit = user.DIB.split('/').reverse();

  const anoInicial =
    parseInt(dataInicialSplit[0], 10) < 2011
      ? 2011
      : parseInt(dataInicialSplit[0], 10);

  const mesInicial =
    parseInt(dataInicialSplit[0], 10) < 2011
      ? 11
      : parseInt(dataInicialSplit[1], 10);

  const opcoesAnos = () => {
    const anos = [];
    const end = getYear(dataAtual) + 1;
    for (let i = anoInicial; i < end; i += 1) {
      if (!(i === anoInicial && mesInicial === 12) && i <= anoLimite) {
        anos.push(i.toString());
      }
    }
    return anos.sort((a, b) => {
      return b.localeCompare(a);
    });
  };

  const retiramesInicialExtrato = () => {
    const opcoesMesesNovo = [];

    if (anoSelecionado === anoInicial) {
      opcoesMeses.map((mes) => {
        if (mes.numero <= mesInicial) opcoesMesesNovo.push(mes);
        return mes;
      });
      setOpcoesMeses(opcoesMesesNovo);
    }
  };

  useEffect(() => {
    if (anoSelecionado !== undefined) setHabilitarSelecaoMeses(true);
    // Habilita botão
    if (mesSelecionado !== '' && anoSelecionado !== '') {
      setHabilitarPDF(true);
    }
    // Regra do ano inicial
    if (parseInt(anoSelecionado, 10) === anoInicial) {
      const opcoesFiltro = [];
      months.forEach((item) => {
        if (parseInt(item.numero, 10) > mesInicial) {
          opcoesFiltro.push(item);
        }
      });
      opcoesFiltro.sort((a, b) => {
        return b.numero.toString().localeCompare(a.numero.toString());
      });
      setOpcoesMeses(opcoesFiltro);
      retiramesInicialExtrato();
    }
    // Regra ano atual, mes limite
    if (
      anoSelecionado === anoLimite &&
      parseInt(anoSelecionado, 10) !== anoInicial
    ) {
      const opcoesFiltro = [];
      months.forEach((item) => {
        if (item.numero <= mesLimite) {
          opcoesFiltro.push(item);
        }
      });
      opcoesFiltro.sort((a, b) => {
        return b.numero.toString().localeCompare(a.numero.toString());
      });
      setOpcoesMeses(opcoesFiltro);
    } else if (
      anoSelecionado !== getYear(dataAtual).toString() &&
      parseInt(anoSelecionado, 10) !== anoInicial
    ) {
      setOpcoesMeses(months);
    }
  }, [mesSelecionado, anoSelecionado, anoInicial, mesInicial]);

  async function baixarArquivoPDF() {
    setIsLoading(true);

    try {
      await api
        .get(urlGetPDF + anoSelecionado + mesSelecionado, {
          responseType: 'arraybuffer',
        })
        .then((res) => {
          const blob = new Blob([res.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `${relatorio} participante - ${user.matricula}.PDF`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } catch (error) {
      toast.error(`Erro ao gerar ${relatorio}`);
    }
  }

  return (
    <div className="card">
      <div className="card-body">
        <h2>
          <strong>Contracheque</strong>
        </h2>
        <div className="row col-12 col-md-8 col-lg-6 mb-4 mt-4">
          {!isLoading ? (
            <>
              <ComboBox
                color={custom.nomeCorPrincipal}
                label="Ano"
                className="mt-3 col-12 col-md4 col-lg-6"
                value={anoSelecionado}
                onChange={setAnoSelecionado}
                tooltip="Selecione o ano de referência"
                options={opcoesAnos().map((x) => {
                  return { value: x, label: x };
                })}
              />
              <ComboBox
                isDisabled={!habilitarSelecaoMeses}
                color={custom.nomeCorPrincipal}
                label="Mês"
                className="mt-3 col-12 col-md4 col-lg-6"
                value={mesSelecionado}
                onChange={setMesSelecionado}
                tooltip="Escolha o mês de referência"
                options={opcoesMeses.map((s) => {
                  return {
                    value: s.numero,
                    label: s.nome,
                  };
                })}
              />
              {habilitarPDF && (
                <Button
                  onClick={() => baixarArquivoPDF()}
                  className="ts-14 mb-2 col-6 mt-4"
                >
                  Baixar
                </Button>
              )}
            </>
          ) : (
            <LoadingIndicator />
          )}
        </div>
      </div>
    </div>
  );
};
